import React, { ReactNode, useEffect } from 'react';
import SidebarMobile from '../components/Sidebar-mobile';
import SidebarDesktop from '../components/Sidebar-desktop';
import Footer from '../components/Footer';
import { navItemsAdmin } from '../data/NavItemsAdmin';
import { updateBodyClass } from '../utils/function';
import Header from '../components/Header';


interface LayoutProps {
  children: ReactNode;
}

const AdminLayout: React.FC<LayoutProps> = ({ children }) => {


  useEffect(() => {
    updateBodyClass('');
  }, []);

  return (
    <div className="wrapper">
      <Header />
      <SidebarMobile navItems={navItemsAdmin} />
      <section className="main-page">
        {/* Pass navItemsAdmin to SidebarDesktop */}
        <SidebarDesktop navItems={navItemsAdmin} />
        {children}
      </section>
      <Footer />
    </div>
  );
};

export default AdminLayout;
